module.exports = __webpack_public_path__ + "img/Hoyin.67d036fc.webp";